"use client";
import { jsxs as n, jsx as l } from "react/jsx-runtime";
const d = ({
  title: a,
  titleId: i,
  desc: r,
  descId: e,
  ...c
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": e,
    ...c,
    children: [
      r ? /* @__PURE__ */ l("desc", { id: e, children: r }) : null,
      a ? /* @__PURE__ */ l("title", { id: i, children: a }) : null,
      /* @__PURE__ */ n("g", { fill: "currentColor", children: [
        /* @__PURE__ */ l("path", { d: "M13.6562.25H6.3438A6.0937 6.0937 0 0 0 .25 6.3438v7.3124A6.094 6.094 0 0 0 6.3438 19.75h7.3124a6.094 6.094 0 0 0 6.0938-6.0938V6.3438A6.0937 6.0937 0 0 0 13.6562.25m4.2657 13.4062c0 2.3522-1.9135 4.2657-4.2657 4.2657H6.3438c-2.3522 0-4.2657-1.9135-4.2657-4.2657V6.3438c0-2.3522 1.9135-4.2657 4.2657-4.2657h7.3124c2.3522 0 4.2657 1.9135 4.2657 4.2657z" }),
        /* @__PURE__ */ l("path", { d: "M10 5.125a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75m0 7.9219A3.0507 3.0507 0 0 1 6.9531 10c0-1.6807 1.3675-3.0469 3.0469-3.0469S13.0469 8.3193 13.0469 10c0 1.6794-1.3675 3.0469-3.0469 3.0469M15.2394 5.409a.6496.6496 0 1 0 0-1.299.6496.6496 0 0 0 0 1.299" })
      ] })
    ]
  }
);
export {
  d as default
};
